import ChevronLeft from '@/assets/svgs/chevron-left.svg?react';
import { Pages } from '@/utils/routes.utils';
import { useResponsive } from '@/utils/useResponsive';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export interface NavigationProps {
  page: string;
  subpage: string;
}


export const Navigation = ({ page, subpage }: NavigationProps) => {
  const navigate = useNavigate();
  const { isMobile } = useResponsive();
  const { t } = useTranslation();

  return (
    <div className={`flex flex-row gap-x-[32px] ${isMobile ? 'justify-between' : ''}`}>
      <button onClick={() => navigate(Pages.HOME)}>
        <div className="flex flex-row items-center gap-x-[10px]">
          <ChevronLeft />
          <div className="text-bodySmall">{t('buttons.back')}</div>
        </div>
      </button>
      <div className="flex flex-row items-center gap-x-[10px]">
        <div className="text-bodyXSmall opacity-50">{page.toLocaleUpperCase()} / </div>
        <div className="text-bodyXSmall">{subpage.toLocaleUpperCase()}</div>
      </div>
    </div>
  );
}